module.exports = __webpack_public_path__ + "img/service-partner.3b31c64e.svg";